import TransactionsList from "../components/TransactionsList"

const Transactions = () => {
  return <TransactionsList/>
}

export default Transactions